import Vue from 'vue'
import VueYoutube from 'vue-youtube'

let isInstalled = false
if (!isInstalled) {
  isInstalled = true
  Vue.use(VueYoutube)
}
